import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class ApprovalLevelNameController implements angular.IComponentController {
    readonly level: number;
    static $inject = [];
}

export const wtApprovalLevelName: ComponentDefinition = {
    componentId: 'wtApprovalLevelName',
    controller: ApprovalLevelNameController,
    template: require('./approvalLevelName.component.html'),
    controllerAs: 'vm',
    bindings: {
        level: '<'
    }
};